// extracted by mini-css-extract-plugin
export default {"icons":"Team_icons__fzYvb","selected-icons":"Team_selected-icons__QzynG"};